export const COLOR_1 = '#093f88'; 